<template>
    <div class="ContentGoodsInfo">
        <div class="nav_box box-shadow">
            <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1" @click="profileData">数据概况</el-menu-item>
                <el-menu-item index="2" @click="traffic">流量分析</el-menu-item>
                <el-menu-item index="3" @click="trading">交易分析</el-menu-item>
                <el-menu-item index="4" @click="content">内容分析</el-menu-item>
                <el-menu-item index="5" @click="user">用户分析</el-menu-item>
            </el-menu>
        </div>
        <div class="select_warp bgc box-shadow" style="margin-top: 20px;">
            <span>选择商品：</span>
            <div style="width: 110px">
                <el-select @change="typeChange" v-model="goodsTypeValue" placeholder="类型">
                    <el-option v-for="item in goodsTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div>
                <el-select v-model="goodsNameValue" filterable placeholder="请选择商品">
                    <el-option v-for="item in goodsNameOptions" :key="item.innerid" :label="item.kmcname" :value="item.innerid"></el-option>
                </el-select>
            </div>
            <div style="width: 100px">
                <el-select v-model="dateOptionValue" placeholder="自然天">
                    <el-option v-for="item in dateTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>

            <div v-show="dateOptionValue === 1">
                <el-date-picker :clearable="false" v-model="dateValue" align="left" type="date" :placeholder="this.getDateTime(0)" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 2">
                <el-date-picker :clearable="false" :picker-options="disabledDatePickerOptions" v-model="dateValue" align="left" type="week" format="yyyy 第 WW 周" placeholder="选择周"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 3">
                <el-date-picker :clearable="false" :picker-options="disabledDatePickerOptions" v-model="dateValue" align="left" type="month" placeholder="选择月"></el-date-picker>
            </div>
            <div v-show="dateOptionValue === 4">
                <el-date-picker
                    :picker-options="disabledDatePickerOptions"
                    :clearable="false"
                    format="yyyy-MM-dd"
                    v-model="periodTime"
                    align="left"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div>
                <el-button type="primary" @click="searchClick" plain>搜索</el-button>
            </div>
        </div>
        <div class="container1 padding-20 bgc box-shadow">
            <div class="title_warp">
                <p>销售情况</p>
                <div class="search_box">
                    <p @click="salesExport"><img :src="reportIcon" alt="">导出</p>
                </div>
            </div>
            <div class="content1">
                <div class="echarts_warp">
                    <ContentEchartsLine1 :saleEchartsData="saleEchartsData"></ContentEchartsLine1>
                </div>
                <div class="pandect_warp">
                    <div class="pandect_item" v-for="(item, index) in pandectData1" :key="index">
                        <p>
                            <span>{{item.title}}</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima, eius repudiandae. Provident sequi quam possimus libero ducimus excepturi dolore sunt neque in, vero omnis deleniti eligendi harum dolorem fugit tenetur!</div>
                                <img class="tooltip_icon" :src="toolsTipsIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{item.num}}</p>
                    </div>
                </div>
            </div>
            <div class="table_warp">
                <Table1 :saleTableData="saleTableData"></Table1>
                <page :total="total1" ref="page2" @getList="findSalesTableData"></page>
            </div>
        </div>
        <div class="container2 padding-20 bgc box-shadow">
            <div class="title_warp">
                <p>使用说明 </p>
                <div class="search_box">
                    <p @click="instructionExport"><img :src="reportIcon" alt="">导出</p>
                </div>
            </div>
            <div class="pandect_warp">
                <div class="pandect_item" v-for="(item, index) in pandectData2" :key="index">
                     <p>
                        <span>{{item.title}}</span>
                        <el-tooltip placement="top">
                            <div class="tooltip_content" slot="content">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima, eius repudiandae. Provident sequi quam possimus libero ducimus excepturi dolore sunt neque in, vero omnis deleniti eligendi harum dolorem fugit tenetur!</div>
                            <img class="tooltip_icon" :src="toolsTipsIcon" alt="">
                        </el-tooltip>
                    </p>
                    <p>{{item.num}}</p>
                </div>
            </div>
            <div class="echarts_warp">
                <ContentEchartsLine2 :instructionEchartsData="instructionEchartsData"></ContentEchartsLine2>
            </div>
            <div class="table_warp">
                <Table2 :instructionTableData="instructionTableData"></Table2>
                <page :total="total2" ref="page1" @getList="findInstructionTableData"></page>
            </div>
        </div>
    </div>
</template>

<script>
import ContentEchartsLine1 from 'views/dataCenter/dataTabs/echarts/ContentEchartsLine1'
import ContentEchartsLine2 from 'views/dataCenter/dataTabs/echarts/ContentEchartsLine2'
import Table1 from 'views/dataCenter/dataTabs/contentComponents/Table1'
import Table2 from 'views/dataCenter/dataTabs/contentComponents/Table2'
import Page from 'base/page/page'
import {getChooseContent, getSalesStatus, getSalesStatusPaging, getInstruction, getInstructionPaging, getSalesProfileExport, getInstructionProfileExport} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'ContentGoodsInfo',
    data() {
        return {
            activeIndex: '4',
            saleEchartsData: {},
            saleTableData: [],
            instructionEchartsData: {},
            instructionTableData: [],
            total1: 0,
            total2: 0,
            img: require('@/common/images/logo.png'),
            toolsTipsIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
            reportIcon: require('@/common/images/other/data_center_report_icon@2x.png'),
            pandectData1: [
                {
                    title: '付费用户数',
                    num: 0
                },
                {
                    title: '付费金额(元)',
                    num: 0
                }
            ],
            pandectData2: [
                {
                    title: '浏览用户数',
                    num: 0
                },
                {
                    title: '评论数',
                    num: 0
                },
                {
                    title: '评论用户数',
                    num: 0
                }
            ],
            tableData: [
                {
                    pm: 1,
                    spmc: '视频课 | 董秘成长E课堂（夯实基础、快速入门）',
                    spfks: 345,
                    zhl: '36%'
                },
                {
                    pm: 2,
                    spmc: '视频课 | 创业企业股权设计',
                    spfks: 122,
                    zhl: '23%'
                },
                {
                    pm: 3,
                    spmc: '视频课 | 董秘成长E课堂（夯实基础、快速入门）',
                    spfks: 100,
                    zhl: '34%'
                },
                {
                    pm: 4,
                    spmc: '视频课 | 创业企业股权设计',
                    spfks: 56,
                    zhl: '22%'
                },
                {
                    pm: 5,
                    spmc: '视频课 | 董秘成长E课堂（夯实基础、快速入门）',
                    spfks: 33,
                    zhl: '46%'
                }
            ],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                },
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24)
                            picker.$emit('pick', date)
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', date)
                        }
                    }
                ]
            },
            disabledDatePickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                }
            },
            dateOptionValue: 1,
            dateTypeOptions: [
                {
                    value: 1,
                    label: '自然天'
                },
                {
                    value: 2,
                    label: '自然周'
                },
                {
                    value: 3,
                    label: '自然月'
                },
                {
                    value: 4,
                    label: '自定义'
                }
            ],
            dateValue: '',
            periodTime: '',
            goodsNameValue: '',
            goodsNameOptions: [],
            goodsTypeValue: '',
            goodsTypeOptions: [
                {
                    value: '',
                    label: '全部类型'
                },
                {
                    value: 1,
                    label: '图文'
                },
                {
                    value: 2,
                    label: '报告'
                },
                {
                    value: 3,
                    label: '直播'
                },
                {
                    value: 4,
                    label: '视频'
                },
                {
                    value: 5,
                    label: '专题'
                }
            ]
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        profileData() {
            this.$router.push({name: 'ProfileData'})
        },
        traffic() {
            this.$router.push({name: 'Traffic'})
        },
        trading() {
            this.$router.push({name: 'Trading'})
        },
        content() {
            this.$router.push({name: 'Content'})
        },
        user() {
            this.$router.push({name: 'User'})
        },
        // 销售情况导出1
        salesExport() {
            if (this.goodsTypeValue === '') {
                this.$message.error(`请选择商品类型！`)
                return
            }
            if (this.goodsNameValue === '') {
                this.$message.error(`请选择商品！`)
                return
            }
            if (this.dateOptionValue === 1 || this.dateOptionValue === 2 || this.dateOptionValue === 3) {
                if (this.dateValue === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            if (this.dateOptionValue === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            this.setLoading(true)
            var params = {}
            if (this.dateOptionValue === 1) {
                params = {
                    beginTime: this.transferDate(this.dateValue),
                    endTime: this.transferDate(this.dateValue)
                }
            } else if (this.dateOptionValue === 2) {
                params = {
                    beginTime: this.getWeek(this.dateValue)[0],
                    endTime: this.getWeek(this.dateValue)[1]
                }
            } else if (this.dateOptionValue === 3) {
                params = {
                    beginTime: this.getMonth(this.dateValue)[0],
                    endTime: this.getMonth(this.dateValue)[1]
                }
            } else if (this.dateOptionValue === 4) {
                params = {
                    beginTime: this.transferDate(this.periodTime[0]),
                    endTime: this.transferDate(this.periodTime[1])
                }
            }
            params.kmctype = this.goodsTypeValue
            params.innerid = this.goodsNameValue
            getSalesProfileExport({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.exportTips = false
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '销售情况' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 使用说明导出1
        instructionExport() {
            if (this.goodsTypeValue === '') {
                this.$message.error(`请选择商品类型！`)
                return
            }
            if (this.goodsNameValue === '') {
                this.$message.error(`请选择商品！`)
                return
            }
            if (this.dateOptionValue === 1 || this.dateOptionValue === 2 || this.dateOptionValue === 3) {
                if (this.dateValue === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            if (this.dateOptionValue === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择导出日期！`)
                    return
                }
            }
            this.setLoading(true)
            var params = {}
            if (this.dateOptionValue === 1) {
                params = {
                    beginTime: this.transferDate(this.dateValue),
                    endTime: this.transferDate(this.dateValue)
                }
            } else if (this.dateOptionValue === 2) {
                params = {
                    beginTime: this.getWeek(this.dateValue)[0],
                    endTime: this.getWeek(this.dateValue)[1]
                }
            } else if (this.dateOptionValue === 3) {
                params = {
                    beginTime: this.getMonth(this.dateValue)[0],
                    endTime: this.getMonth(this.dateValue)[1]
                }
            } else if (this.dateOptionValue === 4) {
                params = {
                    beginTime: this.transferDate(this.periodTime[0]),
                    endTime: this.transferDate(this.periodTime[1])
                }
            }
            params.kmctype = this.goodsTypeValue
            params.innerid = this.goodsNameValue
            getInstructionProfileExport({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.exportTips = false
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '使用说明' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 搜索按钮
        searchClick() {
            if (this.goodsNameValue === '') {
                this.$message.error(`请选择商品！`)
                return
            }
            if (this.dateOptionValue === 1 || this.dateOptionValue === 2 || this.dateOptionValue === 3) {
                if (this.dateValue === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            if (this.dateOptionValue === 4) {
                if (this.periodTime === '') {
                    this.$message.error(`请选择搜索日期！`)
                    return
                }
            }
            var params = {
                kmctype: this.goodsTypeValue,
                innerid: this.goodsNameValue,
                timeStatus: this.dateOptionValue,
                beginTime: this.transferDate(this.dateValue)
            }
            if (this.dateOptionValue === 4) {
                params.beginTime = this.transferDate(this.periodTime[0])
                params.endTime = this.transferDate(this.periodTime[1])
            }
            this.findSalesStatus(params)
            this.findInstruction(params)
            this.handleQuery()
        },
        handleQuery() {
            this.$refs.page1.handleSizeChange(1)
            this.$refs.page2.handleSizeChange(1)
        },
        // 销售情况分页查询
        findSalesTableData() {
            var params = {
                kmctype: this.goodsTypeValue,
                innerid: this.goodsNameValue,
                timeStatus: this.dateOptionValue,
                beginTime: this.dateValue
            }
            if (this.dateOptionValue === 4) {
                params.beginTime = this.periodTime[0]
                params.endTime = this.periodTime[1]
            }
            this.findSalesStatusPaging(params)
        },
        // 使用说明分页查询
        findInstructionTableData() {
            var params = {
                kmctype: this.goodsTypeValue,
                innerid: this.goodsNameValue,
                timeStatus: this.dateOptionValue,
                beginTime: this.dateValue
            }
            if (this.dateOptionValue === 4) {
                params.beginTime = this.periodTime[0]
                params.endTime = this.periodTime[1]
            }
            this.findInstructionPaging(params)
        },
        // 初始化相关数据查询
        init() {
            var params = {
                kmctype: this.$route.query.type,
                innerid: this.$route.query.id,
                timeStatus: 1,
                beginTime: this.getDateTime(0)
            }
            this.findChooseContent(this.$route.query.type)
            this.findSalesStatus(params)
            this.findSalesStatusPaging(params)
            this.findInstruction(params)
            this.findInstructionPaging(params)
        },
        // 获取--商品名称内容下拉框
        findChooseContent(type) {
            this.setLoading(true)
            var params = {
                kmctype: type
            }
            getChooseContent({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsNameOptions = data.data
                    this.goodsNameValue = this.$route.query.id
                    this.goodsTypeValue = this.$route.query.type
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 商品类型下拉框改变查找相应类型商品
        typeChange() {
            this.setLoading(true)
            var params = {
                kmctype: this.goodsTypeValue
            }
            getChooseContent({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsNameValue = ''
                    this.goodsNameOptions = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取销售情况Data
        findSalesStatus(par) {
            this.setLoading(true)
            var params = par
            getSalesStatus({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.saleEchartsData = data.data
                    this.pandectData1[0].num = data.data.orderpaycustomer
                    this.pandectData1[1].num = data.data.orderpaymoney
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取销售情况表格Data
        findSalesStatusPaging(par) {
            this.setLoading(true)
            var params = par
            getSalesStatusPaging({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.saleTableData = data.data.content
                    this.total1 = data.data.splitPage.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取使用说明Data
        findInstruction(par) {
            this.setLoading(true)
            var params = par
            getInstruction({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.instructionEchartsData = data.data
                    this.pandectData2[0].num = data.data[2].visitclientNum
                    this.pandectData2[1].num = data.data[1].commentNum
                    this.pandectData2[2].num = data.data[3].commentUsersNum
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取使用说明表格Data
        findInstructionPaging(par) {
            this.setLoading(true)
            var params = par
            getInstructionPaging({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.instructionTableData = data.data.content
                    this.total2 = data.data.splitPage.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        getWeek(value) {
            // 按周日为一周的最后一天计算
            var date = value
            // 今天是这周的第几天
            var today = date.getDay()
            // 上周日距离今天的天数（负数表示）
            var stepSunDay = -today + 1
            // 如果今天是周日
            if (today === 0) {
                stepSunDay = -7
            }
            // 周一距离今天的天数（负数表示）
            var stepMonday = 7 - today
            var time = date.getTime()
            var monday = new Date(time + stepSunDay * 24 * 3600 * 1000)
            var sunday = new Date(time + stepMonday * 24 * 3600 * 1000)
            // 本周一的日期 （起始日期）
            var startDate = this.transferDate(monday) // 日期变换
            // 本周日的日期 （结束日期）
            var endDate = this.transferDate(sunday) // 日期变换
            return [startDate, endDate]
        },
        getMonth(value) {
            // 获取当前月的第一天
            var start = value
            start.setDate(1)
            // 获取当前月的最后一天
            var date = value
            var currentMonth = date.getMonth()
            var nextMonth = ++currentMonth
            var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
            var oneDay = 1000 * 60 * 60 * 24
            var end = new Date(nextMonthFirstDay - oneDay)
            var startDate = this.transferDate(start) // 日期变换
            var endDate = this.transferDate(end) // 日期变换
            return [startDate, endDate]
        },
        transferDate(date) {
            // 年
            var year = date.getFullYear()
            // 月
            var month = date.getMonth() + 1
            // 日
            var day = date.getDate()
            if (month >= 1 && month <= 9) {
                month = '0' + month
            }
            if (day >= 0 && day <= 9) {
                day = '0' + day
            }
            var dateString = year + '-' + month + '-' + day
            return dateString
        },
        // 获取昨日 日期
        getDateTime(type) {
            // type :  1--今天日期  0--昨天日期
            var time = null
            if (type === 1) {
                time = (new Date()).getTime()
            } else if (type === 0) {
                time = (new Date()).getTime() - 24 * 60 * 60 * 1000
            }
            var dateTime = new Date(time) // 获取的是前一天日期
            var year = dateTime.getFullYear()
            var month = dateTime.getMonth() + 1
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        // 获取本月/上一个月 自然天前上一周日期
        getDateMonthTime(type) {
            var time = (new Date()).getTime() - 7 * 24 * 60 * 60 * 1000
            var dateTime = new Date(time)
            var year = dateTime.getFullYear()
            var month = null
            if (type === 1) {
                month = dateTime.getMonth() + 1
            }
            if (type === 0) {
                month = dateTime.getMonth()
            }
            if (month === 0) {
                month = 12
                year = year - 1
            }
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        goodsTypeValue(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                if (this.goodsTypeValue === '') {
                } else {
                    if (typeof this.$route.query.type === 'string') {
                        this.goodsTypeValue = parseInt(this.goodsTypeValue)
                    }
                }
            })
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        ContentEchartsLine1,
        ContentEchartsLine2,
        Table1,
        Table2,
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ContentGoodsInfo {
    font-family: PingFangSC-Medium;
    .select_warp{
        height: 50px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        margin-bottom: 20px;
        &>span{
            color: #606266;
        }
        &>div {
            height: 36px;
            vertical-align: middle;
            margin-left: 20px;
        }
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 0;
            height: 36px;
        }
        .el-button {
            height: 36px;
        }
        .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
            width: 240px;
        }
        .el-date-editor .el-range-separator {
            line-height: 28px;
        }
    }
    .title_warp {
        padding: 0 20px 0 10px;
        margin-bottom: 20px;
        height: 50px;
        background-color: #F5F7FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &>p {
            border-left: 2px solid #409EFF;
            padding-left: 8px;
            color: #303133;
        }
        .search_box{
            display: flex;
            align-items: center;
            &>p {
                color: #409EFF;
                cursor: pointer;
                img{
                    width: 16px;
                    height: 14px;
                    margin-right: 8px;
                }
            }
        }
    }
    .echarts_warp {
        height: 420px;
        width: 80%;
    }
    .table_warp {
        margin-top: 30px;
        .el-table th>.cell {
            font-weight: 600;
        }
    }
    .container1 {
        margin-bottom: 20px;
        .content1{
            display: flex;
            .pandect_warp{
                padding: 20px 0 20px 0px;
                width: 20%;
                .pandect_item {
                    height: 158px;
                    box-sizing: border-box;
                    border: 1px solid #DCDFE6;
                    color: #606266;
                    padding: 20px;
                    margin-bottom: 20px;
                    &>p {
                        height: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        &>img {
                            width: 14px;
                            height: 14px;
                            cursor: pointer;
                        }
                    }
                    &>p:nth-of-type(2) {
                        height:40px;
                        font-weight:500;
                        font-size:28px;
                        margin-top: 5px;
                    }
                }
            }
        }
    }
    .container2 {
        .pandect_warp {
            display: flex;
            margin-bottom: 20px;
            .pandect_item {
                width: 33.3%;
                height: 100px;
                box-sizing: border-box;
                border: 1px solid #DCDFE6;
                border-right: none;
                color: #606266;
                padding: 20px;
                &>p {
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &>img {
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                    }
                }
                &>p:nth-of-type(2) {
                    height:40px;
                    font-weight:500;
                    font-size:28px;
                    margin-top: 5px;
                }
            }
            .pandect_item:nth-last-of-type(1) {
                border-right: 1px solid #DCDFE6;
            }
        }
        .echarts_warp {
            width: 100%;
        }
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
</style>